
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_1lv73_13",
  "tools": "awsui_tools_wih1l_1lv73_24",
  "tools-filtering": "awsui_tools-filtering_wih1l_1lv73_33",
  "tools-align-right": "awsui_tools-align-right_wih1l_1lv73_46",
  "tools-clear-sort": "awsui_tools-clear-sort_wih1l_1lv73_50",
  "tools-pagination": "awsui_tools-pagination_wih1l_1lv73_53",
  "tools-preferences": "awsui_tools-preferences_wih1l_1lv73_53",
  "tools-small": "awsui_tools-small_wih1l_1lv73_59",
  "table": "awsui_table_wih1l_1lv73_63",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_1lv73_69",
  "wrapper": "awsui_wrapper_wih1l_1lv73_73",
  "variant-stacked": "awsui_variant-stacked_wih1l_1lv73_80",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_1lv73_80",
  "variant-container": "awsui_variant-container_wih1l_1lv73_80",
  "has-footer": "awsui_has-footer_wih1l_1lv73_83",
  "has-header": "awsui_has-header_wih1l_1lv73_86",
  "cell-merged": "awsui_cell-merged_wih1l_1lv73_103",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_1lv73_115",
  "empty": "awsui_empty_wih1l_1lv73_131",
  "loading": "awsui_loading_wih1l_1lv73_135",
  "selection-control": "awsui_selection-control_wih1l_1lv73_144",
  "selection-control-header": "awsui_selection-control-header_wih1l_1lv73_151",
  "selection-control-content-spans-rows": "awsui_selection-control-content-spans-rows_wih1l_1lv73_156",
  "header-secondary": "awsui_header-secondary_wih1l_1lv73_163",
  "variant-full-page": "awsui_variant-full-page_wih1l_1lv73_174",
  "table-has-header": "awsui_table-has-header_wih1l_1lv73_180",
  "header-controls": "awsui_header-controls_wih1l_1lv73_191",
  "variant-embedded": "awsui_variant-embedded_wih1l_1lv73_203",
  "variant-borderless": "awsui_variant-borderless_wih1l_1lv73_203",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_1lv73_208",
  "footer": "awsui_footer_wih1l_1lv73_208",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_1lv73_216",
  "footer-pagination": "awsui_footer-pagination_wih1l_1lv73_224",
  "thead-active": "awsui_thead-active_wih1l_1lv73_228",
  "row": "awsui_row_wih1l_1lv73_229",
  "row-selected": "awsui_row-selected_wih1l_1lv73_230",
  "skeleton-loading-cell": "awsui_skeleton-loading-cell_wih1l_1lv73_234"
};
  